import { render, staticRenderFns } from "./PracticalWorkEvaluations.vue?vue&type=template&id=7e0792c3&scoped=true"
import script from "./PracticalWorkEvaluations.vue?vue&type=script&lang=js"
export * from "./PracticalWorkEvaluations.vue?vue&type=script&lang=js"
import style0 from "./PracticalWorkEvaluations.vue?vue&type=style&index=0&id=7e0792c3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e0792c3",
  null
  
)

export default component.exports